import pluralize from "pluralize";
import React from "react";

import { Box, LinearProgress, useTheme } from "@mui/material";
import { useSelector } from "@src/store";
import {
  getProductPickerLoadedCount,
  getProductPickerProductCount,
} from "@src/store/slices/productPicker";

export const SelectAllProgressBar = () => {
  const loadedCount = useSelector(getProductPickerLoadedCount);
  const theme = useTheme();
  const productCount = useSelector(getProductPickerProductCount);
  const progress =
    productCount !== undefined ? (100 * loadedCount) / productCount : 0;

  const message = `Loading ${loadedCount} of ${productCount} ${pluralize("product", productCount)}`;

  return (
    <Box
      sx={{
        display: "flex",
        width: "300px",
        backgroundColor: "white",
        justifyContent: "center",
        paddingTop: "20px",
        paddingLeft: "30px",
        paddingRight: "30px",
        paddingBottom: "20px",
        flexDirection: "column",
        gap: "10px",
        borderRadius: "3px",
        color: theme.palette.text.primary,
        boxShadow: theme.igShadows.low,
      }}
    >
      <Box>
        <LinearProgress
          sx={{ flex: 1 }}
          variant="determinate"
          value={progress}
        />
      </Box>
      <Box>{message}</Box>
    </Box>
  );
};
